import React from 'react'
import clsx from 'clsx'

export const Subtitle = ({ children, className = '', size = 'text-base', weight = 'font-medium' }) => {
  return <p className={clsx("text-slate font-['Manrope']", size, weight, className)}>{children}</p>
}
